import { render } from "./EditableText.vue?vue&type=template&id=4a48d670&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"

import "./EditableText.vue?vue&type=style&index=0&id=4a48d670&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a48d670"]])

export default __exports__